import React from "react";
import "../../css/sharedStyles.css";
import ComicDetail from "../comicDetail/ComicDetail.js";
import ComicDetailDesktop from "../comicDetail/ComicDetailDesktop.js";
import ComicDetailCharacters from "../comicDetail/ComicDetailCharacters.js";


var ComicDetailLayout = class ComicDetailLayout extends React.Component{
    
    componentDidMount(){
      this.props.changeCurrentPage("comicDetail")
    }//end componentDidMount() 


    render() {
      const inlineStyle = {
        marginBottom:"10px"
      }

      return (
          
        <div>
            <div className = "leftSideContainer">
                <ComicDetail 
                    mainComicInfo = {this.props.mainComicInfo}
                    changeMainComic = {this.props.changeMainComic }
                />
               
            </div>{/* end left side container */}

            <div className = "rightSideContainer">
                
                 <ComicDetailDesktop 
                    mainComicInfo = {this.props.mainComicInfo}
                    changeMainComic = {this.props.changeMainComic }
                 /> 
                 <ComicDetailCharacters 
                    mainComicInfo = {this.props.mainComicInfo}
                    changeCharactersInComic = {this.props.changeCharactersInComic} 
                    changeCharacter = {this.props.changeCharacter} 
                    showComicArea = {this.props.showComicArea} 
                    characterInfo = {this.props.characterInfo}  
                 /> 
               
            </div> {/* end right side container */}




        </div>
      );
    }
  }

  export default ComicDetailLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/comicDetailLayout.js